// src/features/lookup/routes.tsx
import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/routing/rootRoute';
import CountryPage from './pages/country/CountryPage';
import CityPage from './pages/city/CityPage';
import CurrencyPage from './pages/currency/CurrencyPage';
import CityForm from './pages/city/CityForm';
import CountryForm from './pages/country/CountryForm';
import { hasPermission } from '../../common/services/permissionService';
import { API_ENDPOINTS } from './api/apiEndpoints';
import { getPermissionKeyFromApi } from '../../common/components/fromatPermission';

export const lookupRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/lookup',

});
export const countryRoute = createRoute({
    getParentRoute: () => lookupRoute,
    path: '/country',
    component: CountryPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.LOOKUP.GET_COUNTRY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const cityRoute = createRoute({
    getParentRoute: () => lookupRoute,
    path: '/city',
    component: CityPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.LOOKUP.GET_CITY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const CityFormRoute = createRoute({
    getParentRoute: () => lookupRoute,
    path: 'city/CityFormRoute',
    component: CityForm,
});

export const currencyRoute = createRoute({
    getParentRoute: () => lookupRoute,
    path: '/currency',
    component: CurrencyPage,
    beforeLoad: () => {
        if (!hasPermission(getPermissionKeyFromApi(API_ENDPOINTS.LOOKUP.GET_CURRENCY || ""))) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            throw redirect({ to: '/not-authorized' as any });
            //console.log('permission denied');
        }
    },
});

export const CountryFormRoute = createRoute({
    getParentRoute: () => lookupRoute,
    path: 'country/CountryFormRoute',
    component: CountryForm,
});

export const lookupRoutes = [
    lookupRoute,
    countryRoute,
    cityRoute,
    currencyRoute,
    CityFormRoute,
    CountryFormRoute
];